var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00027 7.01911C9.71849 7.01911 11.1114 5.67169 11.1114 4.00956C11.1114 2.34742 9.71849 1 8.00027 1C6.28205 1 4.88916 2.34742 4.88916 4.00956C4.88916 5.67169 6.28205 7.01911 8.00027 7.01911Z",
    stroke: "#7B7A7A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 16.0479C15 12.3081 11.8659 9.27637 8 9.27637C4.13406 9.27637 1 12.3081 1 16.0479",
    stroke: "#7B7A7A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserItem);
export default __webpack_public_path__ + "static/media/user-item.4ad3b93e24bb447b568926abb5ca65c9.svg";
export { ForwardRef as ReactComponent };